<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part-no" id="pt-1"><a id="page_26">Part I</a></h1><a id="page_26">
</a><h1 class="part-title"><a id="page_26"></a><a id="page_27">Arius and the Nicene Crisis</a></h1><a id="page_27">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 010_Part01.vue?e33146d8